import React, {forwardRef, useImperativeHandle, useRef, useState} from 'react';
import {Card, CardBody, CardTitle, Col, Collapse, Form, FormGroup, Input, InputGroup, Label, Row} from 'reactstrap';

import {
    error,
    fileOption,
    FORM,
    IMAGE_FORMATS,
    REQUIRED,
    saveMsg,
    success,
    updateMsg,
} from "../../../components/i18n/i18n";
import Switch from "react-bootstrap-switch";
import {showToastCustom} from "../../../components/toast/customToast";
import * as Yup from "yup";
import {ErrorMessage, useForm} from "react-hook-form";
import {showLoader} from "../../../components/loader/loader";
import {mediaService} from "../../../jwt/_services/clasificator/mediaService";
import {ButtonCollapseEye, ButtonSubmit, GenericTableButton} from "../../../components/buttons/buttonsActions";
import {TT_HISTORY} from "../../../components/i18n/toolTips";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";

export const MediaForm = forwardRef( (props, ref) =>{

    const [editMode, setEditMode] = useState(!!props?.item?.id);

    const [disableInputs, setDisableInputs] = useState(false);
    const [savedData, setSavedData] = useState(editMode ? props.item?.media : null);
    const [relationId, setRelationId] = useState(editMode ? props.item?.id : null);
    const [status, setStatus] = useState(editMode ? props.item?.media.status : true);
    const [loading, setLoading] = useState(false);
    const [changeLocation, setChangeLocation] = useState(editMode);

    const [mediaAccept] = useState(IMAGE_FORMATS);
    const [mediaDefault, setMediaDefault] = useState(editMode ? props.item?.mediaDefault : false);
    const [openForm, setOpenForm] = useState(true);
    const [selectedFile, setSelectedFile] = useState( null);
    const [fileName, setFileName] = useState( editMode ? savedData?.fileName : null);

    const [showModal, setShowModal] = useState(true)
    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(savedData);
    }

    const validationSchema = Yup.object().shape({
        location: Yup.string().required(REQUIRED),
    });

    const {register, handleSubmit, reset, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: savedData?.id,
            uid: savedData?.uid,
            location: savedData?.location,
            mediaDefault: savedData?.mediaDefault
        }
    });

    // ----------------------------------------------
    //            CHANGE HANDLERS
    // ----------------------------------------------
    const onStatusChange = () => {
        setStatus(!status);
    }

    const onMediaDefaultChange = () => {
        setMediaDefault(!mediaDefault);
    }

    const handleChange =(e) =>{
        e.preventDefault();
        let file = e.target.files[0];
        if (file) {
            setSelectedFile(file);
            setFileName(file.name);
        }
    }

    const onLocationChange = (e) => {
        setChangeLocation(true);
        setSavedData({
            id: savedData?.id,
            uid: savedData?.uid,
            location: e.target.value,
            mediaDefault: savedData?.mediaDefault
        });
    }

    // ----------------------------------------------
    //                  SUBMIT
    // ----------------------------------------------
    const onSubmit = (data, _) => {
        if (changeLocation == true && fileName == null ) {
            return showToastCustom(error, fileOption);
        }
        setLoading(true);
        const formData = new FormData();
        formData.set('location', data.location);
        formData.set('status', status);
        formData.append('selectedFile', selectedFile);

        if (!editMode) {
            //Save
            return mediaService.saveItem(formData)
                .then(resultData => {
                    props.saveRelation(resultData.id, mediaDefault)
                        .then((saveOk) => {

                            if (saveOk){
                                showToastCustom(success, saveMsg);
                                resetForm();
                            } else {
                                setLoading(false);
                                showToastCustom(error, 'Ocurrio un error al registrar los datos');
                            }
                        })
                    //saveRelation(resultData.id, mediaDefault)

                })
                .catch(errorMessage => {
                    setLoading(false);
                    showToastCustom(error, errorMessage);
                });
        } else {
            //Update
            let id = savedData.id;
            delete savedData.id;
            return mediaService.updateItem(id, formData)
                .then(_ => {
                    updateRelation(relationId, mediaDefault);
                    showToastCustom(success, updateMsg);
                    resetForm();
                }).catch(errorMessage => {
                    setLoading(false);
                    showToastCustom(error, errorMessage);
                });
        }
    };

    const saveRelation = (id, mediaDefault) => {

    }

    const updateRelation = (id, mediaDefault) => {
        props.updateRelation(id, mediaDefault);
    }

    const resetForm = () => {
        setLoading(false);
        setChangeLocation(false);
        setMediaDefault(false);
        setSavedData(null);
        setStatus(true);
        setEditMode(false);
        setDisableInputs(false);
        setSelectedFile(null);
        setFileName(null);
        reset();
    }

    const showForm = () => {
        setOpenForm(!openForm);
    }

    useImperativeHandle(ref, () => ({
        seFormEdit (item) {
            setRelationId(item?.id);
            setMediaDefault(item?.mediaDefault);
            setStatus(item?.media?.status);
            setSavedData(item?.media);
            setEditMode(true);
        }
    }));

    return (
        <Card>
            {loading && showLoader()}
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-edit mr-2"/>
                {FORM}
                <div className="float-right">
                    <ButtonCollapseEye onClick={() => showForm()} status={openForm}/>
                    {
                        editMode && <GenericTableButton
                            toolTip={TT_HISTORY}
                            icon={'fa-clock'}
                            permission={'search'}
                            onClick={showHistory}
                        />
                    }
                </div>

            </CardTitle>
            <CardBody>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Collapse isOpen={openForm}>
                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label htmlFor="id">ID</Label>
                                <Input type="text" name="id"
                                       disabled
                                       value={editMode ? savedData?.id : ''}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label htmlFor="uid">UID Firebase</Label>
                                <Input type="text" name="uid"
                                       disabled
                                       value={editMode ? savedData?.uid : ''}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="3">
                            <FormGroup>
                                <Label>Ubicación en Firebase</Label>
                                <Input type="text" name="location"
                                       placeholder="root_folder/folder"
                                       innerRef={register}
                                       disabled={disableInputs}
                                       className={(errors.location ? ' is-invalid' : '')}
                                       value={savedData?.location}
                                       onChange={onLocationChange}
                                />
                                <ErrorMessage errors={errors} name="location" component="div" className="invalid-feedback"/>
                            </FormGroup>
                        </Col>
                        <Col md="5">
                            <FormGroup>
                                <Label>Seleccionar archivo</Label>
                                <InputGroup>
                                    <div className="custom-file">
                                        <Input type="file"
                                               name="file"
                                               className="custom-file-input"
                                               accept={mediaAccept}
                                               onChange={handleChange}/>
                                        <label className="custom-file-label" htmlFor="inputGroupFile01">{fileName ? fileName:'Elegir archivo'}</label>
                                    </div>
                                </InputGroup>
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label>Activo</Label>
                                <br/>
                                <Switch animate={true} offText={"No"} onText={"Si"}
                                        innerRef={register}
                                        disabled={disableInputs}
                                        onChange={onStatusChange}
                                        value={status}/>
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label>Imagen principal</Label>
                                <br/>
                                <Switch animate={true} offText={"No"} onText={"Si"}
                                        innerRef={register}
                                        disabled={disableInputs}
                                        onChange={onMediaDefaultChange}
                                        value={mediaDefault}/>
                            </FormGroup>
                        </Col>
                    </Row>

                        <CardBody className="border-top">
                         <div className="float-right">
                            <ButtonSubmit />
                        </div>
                    </CardBody>
                    </Collapse>
                </Form>
            </CardBody>
            {
                showModal && <LogHistoryModal
                    ref={ modalRef }
                    item={ savedData }
                />
            }
        </Card>
    )
})